import { AdminApiService } from '../services';

export const getMeta = async (): Promise<AppMetaType> => {
  const result = await AdminApiService.getCampaignsApiAdminCampaignsGet(
    undefined,
    1_000,
    0
  );
  const campaigns = result.items as AppMetaCampaignType[];

  return {
    campaignsData: campaigns,
    campaignsMap: Object.fromEntries(campaigns.map(item => [item.id, item])),
    campaigns: campaigns
      .map(item => ({ value: item.id, label: item.name }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  };
};
